import React from 'react';
import PropTypes from 'prop-types';
import HorizontalBarChart from './HorizontalBarChart';

const DuracionPromedioPorTipoChart = ({ data, period }) => {
  return (
    <HorizontalBarChart
      data={{
        ...data,
        datasetLabel: 'Duración Promedio (min)',
        xAxisFormatter: (value) => value + ' min'
      }}
      period={period}
      title="Duración Promedio por Tipo de Atención"
      topLabel="Top"
      allLabel="Todos los tipos"
      tooltipSuffix=" minutos"
      defaultTopCount={5}
      noDataIcon="bi-clock-history"
      noDataMessage="No hay datos disponibles para el período seleccionado"
      useConsistentColors={true}
      minHeight={300}
      barHeight={70}
    />
  );
};

DuracionPromedioPorTipoChart.propTypes = {
  data: PropTypes.shape({
    labels: PropTypes.arrayOf(PropTypes.string).isRequired,
    data: PropTypes.arrayOf(PropTypes.number).isRequired,
  }),
  period: PropTypes.string.isRequired,
};

export default DuracionPromedioPorTipoChart;
